<template>
  <div class="campaigns row-1">
    <h3
      v-if="props.title"
      class="campaigns-title title-medium3 is-medium-bold"
      v-html="props.title"
    />
    <div
      v-if="props.items?.length > 0"
      class="campaigns-container p-top-5 p-bot-6"
    >
      <ul class="campaigns-list">
        <li
          class="campaigns-list-item"
          v-for="(campaign, index) in props.items"
          :key="index"
        >
          <nuxt-link
            v-if="campaign.file"
            :to="campaign.file[0].url"
            target="_blank"
            class="flex is-align-center --justify-space-between campaigns-list-item-link text-base4"
          >
            <div
              class="campaigns-list-item-campaign"
              v-html="campaign.sectionTitle"
            />

            <div class="campaigns-list-item-img-wrap show-for-large">
              <div class="campaigns-list-item-img">
                <img
                  :src="campaign.portrait[0].url"
                  :alt="campaign.portrait[0].title"
                />
              </div>
            </div>

            <p class="campaigns-list-item-download">Download</p>
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignsList',
}
</script>

<script setup>
const props = defineProps({
  title: String,
  items: {
    type: Array,
    default: () => [],
  },
})
</script>

<style lang="scss">
@import './style.scss';
</style>
